
/* injects from baggage-loader */

/* globals Editor, _ */
/* jshint browser: true */
'use strict';

const indexOf = [].indexOf || function (item) {
  for (let i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

const moduleModulesSettings = angular.module('editor.modulesSettings.controller', ['services', 'directives.htmlcompiler']);

moduleModulesSettings.controller('blockEditDialogCtrl', [
  '$scope', '$rootScope', '$state', '$timeout', '$templateCache', '$compile', '$sce', 'ns', 'insertBlockMenu',
  'blockEditDialog', 'Section', 'editorDragPanel', 'layoutEditor', 'Tutorials', 'TimeMachine', 'blockDragDrop', '$filter', 'EditorLibrary',
  ($scope, $rootScope, $state, $timeout, $templateCache, $compile, $sce, ns, insertBlockMenu,
   blockEditDialog, Section, editorDragPanel, layoutEditor, Tutorials, TimeMachine, blockDragDrop, $filter, EditorLibrary) => {
    window.tplsFolder = './editor/widget_settings';
    window.settingFolder = './editor/modules_settings';
    $scope.widget = undefined;

    let unbindSectionWatcher;
    let unbindWidgetWatcher;

    const resetAccordion = function() {
      $scope.accordion = {
        show_text: false,
        show_name: false,
        show_vocation: false,
        show_button: false,
        show_image: false,
        show_price: false,
        show_desc: false,
        show_style: false,
        show_title: false,
        show_form_fields: false,
        show_fast_settings: true,
        show_nav_settings: true,
        show_subscribe_add_categories: true,
        show_subscribe_actions: true,
        show_subscribe_add_ex_categories: false,
        show_subscribe_fast_settings: false,
        show: function(type) {
          angular.forEach($scope.accordion, function(value, key) {
            if (typeof $scope.accordion[key] !== 'function') {
              $scope.accordion[key] = false;
            }
          });

          this['show_' + type] = true;
          if (!$scope.$$phase) {
            $scope.$apply();
          }
        }
      };
    };
    resetAccordion();

    $scope.setButtonSize = function(style_attributes1, style_attributes2, size) {
      switch (size) {
        case 'small':
          style_attributes1.padding = '11px 48px 11px 48px';
          style_attributes1.fontSize = '16px';
          style_attributes2.padding = '11px 48px 11px 48px';
          style_attributes2.fontSize = '16px';
          break;
        case 'medium':
          style_attributes1.padding = '17px 58px 17px 58px';
          style_attributes1.fontSize = '18px';
          style_attributes2.padding = '17px 58px 17px 58px';
          style_attributes2.fontSize = '18px';
          break;
        case 'big':
          style_attributes1.padding = '21px 67px 21px 67px';
          style_attributes1.fontSize = '22px';
          style_attributes2.padding = '21px 67px 21px 67px';
          style_attributes2.fontSize = '22px';
          break;
      }
    };
    $scope.setDesignTab = function(tab) {
      $scope.currentDesignTab = tab;
    };

    const destroyAccordion = $rootScope.$on('accordion:show', function(e, type) {
      $scope.accordion.show(type);
    });

    $scope.clearDialog = function() {
      $scope.settings = {body: ''};
    };

    const blockIsEditing = function(e) {
      const currentBlockJson = blockEditDialog.currentBlockJson;

      if (!currentBlockJson) {
        return false;
      }

      const blockId = blockEditDialog.getBlockId(e);

      return blockId === currentBlockJson.id;
    };
    const unbindWatchers = function() {
      $scope.clearDialog();

      if (!$scope.$$phase) {
        $scope.$apply();
      }
      if (unbindSectionWatcher) {
        unbindSectionWatcher();
      }
      if (unbindWidgetWatcher) {
        unbindWidgetWatcher();
      }
    };

    $scope.$on('$destroy', function() {
      destroyAccordion();
      unbindWatchers();
    });

    const setWidgetValues = function() {
      unbindWidgetWatcher = $scope.$watch('widget', function(newval) {
        if (!newval) {
          return false;
        }
        return blockEditDialog._onChangeWidget(newval);
      }, true);

      $scope.widget = blockEditDialog.getWidgetSettings();
      const widgetType = $scope.widget.type;
      $scope.getBody(widgetType);
    };
    const setSectionValues = function() {
      unbindSectionWatcher = $scope.$watch('section', function(newval, oldval) {
        if (!newval) {
          return false;
        }
        return blockEditDialog._onChangeSection(newval, oldval);
      }, true);

      $scope.section = blockEditDialog.getSectionSettings();
      $scope.section.colors = _.map($scope.section.colors, function(tag, index) {
        return {
          text: tag,
          id: index
        };
      });

      if (typeof $scope.section.tags === 'string') {
        $scope.section.tags = _.map($scope.section.tags.split(','), function(tag, index) {
          return {
            text: tag,
            id: index
          };
        });
      }

      $scope.getBodySectionSettings();
    };

    const subscribeFormCategorySelected = function(categories, cb) {
      let hasCategories = false;

      if (_.find(categories, 'selected')) {
        hasCategories = true;
      } else {
        for (let i = 0; i < categories.length; i++) {
          if (_.find(categories[i].groups, 'selected')) {
            hasCategories = true;
            break;
          }
        }
      }

      if (!hasCategories) {
        EditorLibrary.createError($rootScope, 'subscribe_form.categories', $filter('translate')('widget.form.groupRequired'));

        const editorNavigationCtrlScope = $('[ng-controller=\'EditorNavigationCtrl\']').scope();
        editorNavigationCtrlScope.editCurrentTab = 'blockSettings';

        $timeout(() => {
          $scope.accordion.show_subscribe_add_categories = true;
        });
        return false;
      } else {
        EditorLibrary.clearError($rootScope, 'subscribe_form.categories');
        return cb();
      }
    };

    const formCategorySelected = function(categories, cb) {
      let allGroupsSelectFields = [];

      categories.forEach(function(category) {
        return category.groups.forEach(function(group) {
          return allGroupsSelectFields.push(group.selected);
        });
      });

      if (indexOf.call(allGroupsSelectFields, true) < 0 && allGroupsSelectFields.length > 0) {
        $rootScope.alertDialog({
          title: $filter('translate')('alert.form.title'),
          text: $filter('translate')('alert.form.text'),
          accept_text: $filter('translate')('alert.confirm'),
          cancel_text: $filter('translate')('alert.cancel'),
          accept: function() {
            return cb();
          }
        });
      } else {
        return cb();
      }
    };
    const checkFormGroups = function(cb) {
      const {type, product_selected, categories, form_type, disable_form_settings} = blockEditDialog.currentBlock.widget;

      if (type === 'subscribe_form' && !product_selected && !disable_form_settings) {
        return subscribeFormCategorySelected(categories, cb);
      } else if (type === 'form' && form_type === 'subscription') {
        return formCategorySelected(categories, cb);
      } else {
        return cb();
      }
    };
    const formOffertUrlBlank = function(widget, cb) {
      const field = _.filter(widget.form_fields_attributes, {offert: true})[0];
      const index = widget.form_fields_attributes.indexOf(field);
      const regExpUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
      const offertUrlValid = regExpUrl.test(field.offert_url);
      const linkTargetIsNone = field.offert && field.exist && field.link_href_target === 'none' && !field.offert_url;

      if (field.offert && field.exist && field.link_href_target === 'blank' && !offertUrlValid || linkTargetIsNone) {
        if (index > -1) {
          $rootScope.alertDialog({
            title: $filter('translate')('alert.form_offert.title'),
            text: $filter('translate')('alert.form_offert.text'),
            accept_text: $filter('translate')('alert.confirm'),
            cancel_text: $filter('translate')('alert.cancel'),
            accept: function() {
              widget.form_fields_attributes[index].exist = false;
              cb();
            },
            cancel: function() {}
          });
        }
      } else {
        return cb();
      }
    };
    const checkOffertUrl = function(cb) {
      if (blockEditDialog.currentBlock.widget.type === 'form') {
        return formOffertUrlBlank(blockEditDialog.currentBlock.widget, cb);
      } else {
        return cb();
      }
    };

    $rootScope.editSection = function() {
      checkOffertUrl(function() {
        checkFormGroups(function() {
          resetAccordion();

          const section = blockEditDialog.currentBlock.ancestor(ns.sectionClass);
          const e = {target: section};
          const $tools = $('.e__tools');

          $timeout(function() {
            return editorDragPanel._onClickEditSection(e, true, false);
          });
          layoutEditor.save();
          $scope.accordion.show_additional = false;
          blockDragDrop.widgetsCapture();

          $tools.scope().editorNavOpenWidget = false;
          $tools.scope().editorNavOpenWidgetText = false;
          if (!$tools.scope().$$phase) {
            $tools.scope().$apply();
          }
        });
      });
    };
    $scope.setValues = function(e) {
      if (blockIsEditing(e) && $scope.widget) {
        return false;
      }

      unbindWatchers();
      $rootScope.editorNavTab('blockSettings');
      blockEditDialog.setBlock(e);

      const editingBlockType = blockEditDialog.currentBlockType;
      if (editingBlockType === 'widget') {
        setWidgetValues(e);
        $rootScope.widgetIsEditing = true;
      } else {
        setSectionValues(e);
        $rootScope.widgetIsEditing = false;
      }

      $timeout(function() {
        $('#mini-sections').perfectScrollbar('update');
        $(window).resize();
      });
    };
    $scope.getBodySectionSettings = function() {
      let bodyUrl;

      if (!$scope.section.for_email) {
        bodyUrl = './editor/section_settings/common/body.jade';
      }
      if ($scope.section.for_email) {
        bodyUrl = './editor/section_settings/common/email-body.jade';
      }
      if (Editor.mode === 'form.page.editor') {
        bodyUrl = './editor/section_settings/common/form-body.jade';
      }

      const body = $templateCache.get(bodyUrl);
      $scope.settings = {body};
    };
    // Загрузка настроек
    $scope.getBody = function(type) {
      const bodyUrl = window.tplsFolder + '/' + type + '/body.jade';
      const body = $templateCache.get(bodyUrl);

      $scope.settings = {body};
    };
    $scope.clearDialog();
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/blockEditDialog.controller.js